import {Box, Container, Typography} from '@mui/material';
import React, {useContext, useEffect} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {useLanguage} from '../../language/LanguageProvider';
import {Service} from '../../lib/types/Inquiry';
import {saveSelectedServiceTasks, saveSelectedServiceType} from '../../store/actions';
import {AppContext} from '../../store/appContext';
import {ButtonPrimaryLarge} from '../Buttons';
import {CssGrid, DefaultGridPageLayout} from '../Layout';
import {ButtonLayout, SelectServiceCheckboxOptions, Specification} from './InquiryDetailComponents';
import {
    getInquirySummaryPath,
    getInquiryTimeSelectionPath,
    useRedirectWhenUsingQRCodeWithWrongServiceId,
} from './InquiryPageRoutes';

export const InquirySelectServiceTaskPage: React.FC = () => {
    const {serviceId} = useParams<{serviceId: string}>();
    const {state, dispatch} = useContext(AppContext);
    const parsedServiceId = parseInt(serviceId);
    
    useEffect(() => {
        if (!state.inquiry.inProgress) {
            (async () => {
                const service = state.allServicesArray?.find((s) => s.id === parsedServiceId);
                const cameFromQRCode = sessionStorage.getItem('fromQRCode') === 'true';
                if (service) {
                    dispatch(saveSelectedServiceType(service));
                    if (
                        parsedServiceId === 177 &&
                        cameFromQRCode &&
                        service.children &&
                        (!state.inquiry.selectedServiceTasks || state.inquiry.selectedServiceTasks.length === 0)
                    ) {
                        const tasks = Object.values(service.children);
                        const defaultTask = tasks.find((t) => t.id === 6824);
                        if (defaultTask) {
                            setSelectedTasks([defaultTask]);
                            dispatch(saveSelectedServiceTasks([defaultTask]));
                        }
                        sessionStorage.removeItem('fromQRCode');
                    }
                }
            })();
        }
    }, [state.inquiry.inProgress, dispatch, state.allServicesArray]);

    //Redirect to initial inquiry page if there is no active inquiry
    useRedirectWhenUsingQRCodeWithWrongServiceId(parsedServiceId);

    const {getLangString} = useLanguage();
    const [selectedTasks, setSelectedTasks] = React.useState<Service[]>(state.inquiry.selectedServiceTasks || []);
    const handleChange = (services: Service[]) => {
        setSelectedTasks([...services]);
    };

    const availableServiceTasks: Service[] | undefined = state.inquiry.selectedService
        ? state.inquiry.selectedService.children
        : undefined;
    const history = useHistory();
    const navigateToNextPage = () => {
        selectedTasks.length && dispatch(saveSelectedServiceTasks(selectedTasks));
        state.inquiry.isEditing ? history.push(getInquirySummaryPath()) : history.push(getInquiryTimeSelectionPath());
    };

    return (
        <Container sx={{pt: 4, pb: 7}}>
            <CssGrid>
                <DefaultGridPageLayout>
                    <Typography variant={'subtitle1'}>{getLangString('CRAFTSMAN_TASK_HEADER')}</Typography>
                    <SelectServiceCheckboxOptions
                        handleChange={handleChange}
                        availableOptions={availableServiceTasks}
                        selectedOptions={selectedTasks}
                    />
                    <Box marginTop={7}>
                        <Specification />
                    </Box>
                    <ButtonLayout>
                        <ButtonPrimaryLarge onClick={navigateToNextPage} disabled={!selectedTasks.length}>
                            {getLangString('NEXT')}
                        </ButtonPrimaryLarge>
                    </ButtonLayout>
                </DefaultGridPageLayout>
            </CssGrid>
        </Container>
    );
};
